/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';
import 'can/util/util';
import appConfig from 'scripts/app-config';


export default Construct.extend({
    init: function () {
        this.brightcoveOptions = _.get(window.globalSettings, 'brightcove', {});
    },

    getVideo: function (videoId) {
        return can.ajax({
            url: can.sub(_.get(appConfig, 'urls.api.brightcove.apiUrl'), {
                accountId: this.brightcoveOptions.accountId,
                videoId
            }),
            dataType: 'json',
            headers: {
                'Accept': `application/json;pk=${this.brightcoveOptions.policyKey}`
            }
        }).fail((error) => console.error(error));
    }
}, {});
